import * as React from "react";
import type { SVGProps } from "react";
export const RiotLogo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Brands">
      <mask id="mask0_5628_6709" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect id="fill" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5628_6709)">
        <path
          id="Union"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2 8.1936L13.2149 3L22 5.20052V16.7152L18.3654 17.1615L16.9154 8.93732L16.216 9.24844L16.9234 17.3386L13.2467 17.7905L11.9205 10.2704L11.229 10.5781L11.8751 17.9586L8.24049 18.4048L7.03463 11.5693L6.33632 11.8804L6.92109 18.5672L4.79437 18.8283L2 8.1936ZM13.6634 20.176L13.4783 19.1291H13.4829L22 18.0822V21.5658L13.6634 20.176Z"
          fill="#5c5c8e"
        />
      </g>
    </g>
  </svg>
);
